/* src/app/dialogs/import-addresses-wizard/import-addresses-wizard.component.css */
a:link,
a:visited {
  color: #000000;
  text-decoration: underline;
}
a:hover,
a:active {
  color: #000000;
  text-decoration: none;
}
/*# sourceMappingURL=import-addresses-wizard.component-LQP47VZC.css.map */
